import React, { forwardRef } from 'react';

import abby from 'src/helpers/abby';
import { trimPath } from 'src/helpers/path-matching-helper';

type AbbyChatLinkProps = {
  style?: React.CSSProperties;
  children: React.ReactNode;
  className?: string;
  handleClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

const ABBY_CHAT_LINK = 'open-abby-chat';

export const isAbbyChatLink = (to: string | null | undefined) =>
  to && trimPath(to) === ABBY_CHAT_LINK;

const AbbyChatLink = forwardRef<HTMLElement, AbbyChatLinkProps>(
  ({ style, children, className, handleClick, ...otherProps }, ref) => {
    return (
      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className={`${className} abby-chat-link`}
        style={style}
        onClick={(event) => {
          abby.open();
          handleClick?.(event);
        }}
        {...otherProps}
      >
        {children}
      </div>
    );
  }
);

AbbyChatLink.displayName = 'AbbyChatLink';

export default AbbyChatLink;
